import '../assets/styles/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p className='footer_content'>© {new Date().getFullYear()} Buddy Tech Solution . All rights reserved.</p>
    </footer>
  );
};

export default Footer;
